import React, { useEffect, cloneElement, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import useAmplitude from "../../../../hooks/useAmplitude";
import { setQuestionViewAction } from "../../../../redux/answeringQuestions/questionView";

const ScribbleCleaner = ( props ) => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );
  const questionView = useSelector( state => state.questionView );

  const dispatch = useDispatch();
  const { setAmplitudeLog } = useAmplitude();
  const setQuestionView = payload => { dispatch( setQuestionViewAction( payload ) ) };

  useEffect( () => {
    answeringQuestions.data.qstCd && clearScribble();
  }, [ answeringQuestions.data.qstCd ] );

  const clearScribble = ( event ) => {
    if ( questionView.scribbleCanvasDraw ) {
      questionView.scribbleCanvasDraw.clear();
      setQuestionView( { isScribble : false, isErase: false } );

      const amplitudeEvent = !answeringQuestions?.learningType
        ? { eventCategory: 'test', eventName: '진단연습장 초기화', isHackleSend: true }
        : { eventCategory: 'learning', eventName: '학습연습장 초기화', isHackleSend: true, }

      if (!amplitudeEvent || !event) return;
      setAmplitudeLog(amplitudeEvent);
    }
    event && event.stopPropagation();
  };

  return cloneElement( props.children || <Fragment />, {
    onClick : clearScribble,
  } );

};

export default ScribbleCleaner;
